import { useTranslate } from '@tolgee/react';
import type { LinkHTMLAttributes } from 'react';
import type { MenuItem } from '~/model/MenuItem';
import { AppLink } from '~/components/AppLink';

export function MenuItemLink(
  props: Props & (LinkHTMLAttributes<any> | Record<string, any>),
) {
  const { t } = useTranslate();

  const item = props.item || {};

  const ItemLink = item.route ? AppLink : 'a';

  const linkProps: Record<string, any> = {
    ...props,
  };

  // Delete all base props
  delete linkProps.item;

  if (item.route) {
    linkProps.to = item.route;
    linkProps.params = item.params;
    linkProps.hash = item.hash;
  } else {
    linkProps.href = linkProps.href || item.href;
  }

  if (item.onClick) {
    const existingOnClick = linkProps.onClick;
    linkProps.onClick = (e: React.MouseEvent) => {
      item.onClick(e);
      if (!e.defaultPrevented && existingOnClick) {
        existingOnClick(e);
      }
    };
  }

  if (!linkProps.children) {
    linkProps.children = t(item.name);
  }

  // FIXME: This disables typing and could be improved
  return <ItemLink {...(linkProps as any)} />;
}

interface Props {
  readonly item: MenuItem;
}
